/* eslint-disable react/jsx-key */
import selectSourceHandler from "@crescentParts/Handlers/Custom/SelectSourceHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableHeader, DataTableRow } from "@insite/mobius/index";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    selectSourceHandler
};

type Props = ResolveThunks<typeof mapDispatchToProps>;

export interface SelectSourceFormStyles {
    formWrapper?: InjectableCss;
    selectSourceSectionWrapper?: GridContainerProps;
    selectSourceGridItem?: GridItemProps;
    numberLookUpGridItem?: GridItemProps;
    searchGridItem?: GridItemProps;
    selectSourceDropdown: SelectPresentationProps;
    searchButton?: ButtonPresentationProps;
    numberLookUpTextField?: TextFieldPresentationProps;
    serialNumberDiv?: GridContainerProps;
    serialNumberTypo: InjectableCss;
    title: InjectableCss;
    tableWrapper: InjectableCss;
    dataTableHeaderCss?:DataTableHeaderProps;
    dataTableWidthOne: DataTableProps;
    dataTableWidthTwo: DataTableProps;
}

export const selectSourceFormStyles: SelectSourceFormStyles = {
    formWrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
        `,
    },
    selectSourceSectionWrapper: {
        css: css`
        background: rgba(225, 221, 226, 0.3);
        width: 80%;
        margin: 0 auto;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
               null,
               null,
                css``,
                css``,
                css`width: 65%;`,
            ])}
            > ${GridOffset} {
                width: 100%;
                margin: 0;
            }
        `,
    },
    selectSourceGridItem: {
        width: [12, 12, 6, 5, 5]
    },
    numberLookUpGridItem: {
        width: [12, 12, 6, 5, 5]
    },
    searchGridItem: {
        width: [12, 12, 12, 2, 2]
    },
    selectSourceDropdown: {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
    searchButton: {
        css: css`
        margin-top: 32px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
               null,
               null,
                css`margin-top: 0;`,
                null,
                null,
            ], "max",)}
        `
    },
    serialNumberDiv: {
        css: css`
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-top: 50px;
        `
    },
    serialNumberTypo: {
        css: css`
            word-break: break-word;
            `
        },
        title: {
            css: css`
            font-size: 30px;
            font-weight: 700;
            margin: 10px 0px;
        `
    },
    tableWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `
    },
    dataTableHeaderCss: {
        css: css`
            position: sticky;
            top: 0;
            z-index: 1;
        `
    },
    dataTableWidthOne: {
        cssOverrides:{
            evenRow: css`
            width: 50vw;
        `
        }
    },
    dataTableWidthTwo: {
        cssOverrides:{
            evenRow: css`
            width: 55vw;
        `
        }
    }
};

const styles = selectSourceFormStyles;

interface Response {
    key: string,
    value: string
}

function SerialLookupComponent(props: any){

    const {responseData, tableHeight} = props;

    const { Model, ModelDescription, SerialNo } = responseData[0];
  
    return (
        <StyledWrapper {...selectSourceFormStyles.tableWrapper}>
        <StyledWrapper style={{marginTop: '1rem', height: `${tableHeight}px`, overflowY: "auto", overflowX: "hidden", width: 'fit-content'}}>
            <DataTable {...styles.dataTableWidthOne}>
                <DataTableHead>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Serial Number")}</DataTableHeader>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Model Number")}</DataTableHeader>
                </DataTableHead>
                <DataTableBody>
                {      
                    (responseData && responseData.map(({ Model, ModelDescription, SerialNo }: SerialLookup) => (
                    <DataTableRow key={Model}>
                        <DataTableCell alignX="center">{SerialNo}</DataTableCell>
                        <DataTableCell alignX="center">{Model}</DataTableCell>
                    </DataTableRow>
                    )
                    ))
                }
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
        </StyledWrapper>
    );
}

function ModelLookupComponent(props: any){
    
    const {responseData, tableHeight} = props;
  
    return (
        <StyledWrapper {...selectSourceFormStyles.tableWrapper}>
        <StyledWrapper style={{marginTop: '1rem', height: `${tableHeight}px`, overflowY: "auto", overflowX: "hidden", width: 'fit-content'}}>
            <DataTable {...styles.dataTableWidthOne}>
                <DataTableHead>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Model Number")}</DataTableHeader>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Model Description")}</DataTableHeader>
                </DataTableHead>
                <DataTableBody>
                {      
                    (responseData && responseData.map(({ Model, ModelDescription, SearchedModel }: ModelLookup) => (
                    <DataTableRow key={Model}>
                        <DataTableCell alignX="center">{Model}</DataTableCell>
                        <DataTableCell alignX="center">{ModelDescription}</DataTableCell>
                    </DataTableRow>
                    )
                    ))
                }
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
        </StyledWrapper>
    );
}

function UnitPartListComponent(props: any){
    
    const {responseData, value, tableHeight} = props;
      
    return (
        <StyledWrapper {...selectSourceFormStyles.tableWrapper}>
        <StyledWrapper style={{marginTop: '1rem', height: `${tableHeight}px`, overflowY: "auto", overflowX: "hidden", width: 'fit-content'}}>
            <DataTable {...styles.dataTableWidthTwo}>
                <DataTableHead>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Part Number")}</DataTableHeader>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Description")}</DataTableHeader>
                </DataTableHead>
                <DataTableBody>
                    {
                        responseData.map((item: UnitPartListModel) => 
                       ( <DataTableRow key={item.PartNumber}>
                        <DataTableCell alignX="center">{item.PartNumber}</DataTableCell>
                        <DataTableCell style={{whiteSpace: "inherit"}} alignX="center">{item.Description}</DataTableCell>
                    </DataTableRow>)
                     )
                    }
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
        </StyledWrapper>
    );
}

function SupersessionComponent(props: any) {

    const {responseData, tableHeight} = props;
  
    return (
        <StyledWrapper {...selectSourceFormStyles.tableWrapper}>
        <StyledWrapper style={{marginTop: '1rem', height: `fit-content`, overflow: "auto", width: 'fit-content'}}>
            <DataTable {...styles.dataTableWidthTwo}>
                <DataTableHead>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Product Number")}</DataTableHeader>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Description")}</DataTableHeader>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Previous Part")}</DataTableHeader>
                    <DataTableHeader alignX="center" {...styles.dataTableHeaderCss}>{translate("Parts That Supersede Me")}</DataTableHeader>
                </DataTableHead>
                <DataTableBody>
                {      
                    (responseData && responseData.map(({ Description, PartNumber, PartsISupersede, PartsThatSupersedeMe }: SupersessionModel) => (
                    <DataTableRow key={PartNumber}>
                        <DataTableCell alignX="center">{PartNumber}</DataTableCell>
                        <DataTableCell alignX="center">{Description}</DataTableCell>
                        <DataTableCell alignX="center" style={{whiteSpace: "inherit"}}>{PartsISupersede}</DataTableCell>
                        <DataTableCell alignX="center" style={{whiteSpace: "inherit"}}>{PartsThatSupersedeMe}</DataTableCell>
                    </DataTableRow>
                    )
                    ))
                }
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
        </StyledWrapper>
    );
}

interface SerialLookup {
    Model: string,
    ModelDescription: string,
    SerialNo: string
}

interface ModelLookup {
    Model: string,
    ModelDescription: string,
    SearchedModel: string
}

interface SupersessionModel {
    Description: string,
    PartNumber: string,
    PartsISupersede: string,
    PartsThatSupersedeMe: string
}


interface UnitPartListModel {
    PartNumber: string,
    Description: string
}

const SelectSourceForm : React.FC<Props> = ({ selectSourceHandler }) => {
    const [source, setSource] = React.useState("");
    const [placeholder, setPlaceholder] = React.useState("Enter Keyword Or Item");
    const [value, setValue] = React.useState<string>("");
    const [showResponse, setShowResponse] = React.useState<boolean>(false);
    const [inProcess, setInProcess] = React.useState<boolean>(false);
    const [responseData, setResponseData] = React.useState<Response[]>([]);
    const [serialLookupData, setserialLookupData] = React.useState<SerialLookup[]>([]);
    const [modelLookupData, setModelLookupData] = React.useState<ModelLookup[]>([]);
    const [supersessionData, setsupersessionData] = React.useState<SupersessionModel[]>([]);
    const [unitPartListData, setunitPartListData] = React.useState<UnitPartListModel[]>([]);
    const toasterContext = React.useContext(ToasterContext);


    const handleSelectedSource: SelectProps["onChange"] = event => {
        const selectedSourceValue = event.target.value;
        setShowResponse(false);
        setValue("");
        setSource(selectedSourceValue);
        if (selectedSourceValue === "serialLookup") {
            setPlaceholder("Enter Serial Number");
        } else if (selectedSourceValue === "modelLookup"){
            setPlaceholder("Enter Model Number");
        } else if (selectedSourceValue === "unitPartList"){
            setPlaceholder("Enter Model Number");
        } else if (selectedSourceValue === "supersession"){
            setPlaceholder("Enter Component Number");
        } else if (selectedSourceValue === ""){
            setPlaceholder("Enter Keyword Or Item");
        }
    };

    function breakStrings(str: string){
        const arr = str.split(',');
        const result = [];
        let row = '';

        for (let i = 0; i < arr.length; i++) {
        if (i % 4 === 0 && i !== 0) {
            result.push(row);
            row = '';
        }
        row += arr[i];
        if (i !== arr.length - 1) {
            row += ',';
        }
        }

        result.push(row);

        const output = result.join('\n')

        return output
    }

    const displayData = (response: any) => {

        setShowResponse(true);
        if(source === "serialLookup"){
            const updatedtempArr = []
            const updatedtempObj: SerialLookup = response;
            if(updatedtempObj.Model){
                updatedtempArr.push(updatedtempObj);
                return setserialLookupData(updatedtempArr);
            }
        } else if(source === "modelLookup"){
            if(response !== "Error"){
                const tempArr = [...response];
                return setModelLookupData(tempArr);
            }
        } else if (source === "unitPartList"){
            if(response?.Parts){
                const tempArr : any = [...response?.Parts];
                const updatedArr = tempArr.map(({PartNumber, Description}: UnitPartListModel) => ({PartNumber, Description}));
                const sortedArr = updatedArr.sort((a: { PartNumber: string; }, b: { PartNumber: string; }) => a.PartNumber.localeCompare(b.PartNumber));
                return setunitPartListData(sortedArr)
            }
        } else if(source === "supersession"){
            if(response.Description){
                const updatedResponse = [response];
                const filteredData: SupersessionModel[] = updatedResponse.map(
                    ({
                      Description,
                      PartNumber,
                      PartsISupersede,
                      PartsThatSupersedeMe
                    }: {
                      Description: string,
                      PartNumber: string,
                      PartsISupersede: Array<{ PartNumber: string }>,
                      PartsThatSupersedeMe: Array<{ PartNumber: string }>
                    }) => ({
                      Description,
                      PartNumber,
                      PartsISupersede:
                        PartsISupersede.length === 0
                          ? ''
                          : 
                          breakStrings(PartsISupersede.map(({ PartNumber }) => PartNumber).toString()),
                      PartsThatSupersedeMe:
                        PartsThatSupersedeMe.length === 0
                          ? ''
                          : 
                          breakStrings(PartsThatSupersedeMe.map(({ PartNumber }) => PartNumber).toString())
                    })
                  );
                return setsupersessionData(filteredData)
            }
        } else {
            setResponseData(response)
        }
        setserialLookupData([]);
        setModelLookupData([]);
        setsupersessionData([]);
        setunitPartListData([]);
        toasterContext.addToast({ body: translate("Data not found"), messageType: "danger" });
    }

    const handleFormSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        setInProcess(true);
        selectSourceHandler({ 
            apiRoute: source,
            serialNumber: value,  
            onComplete(result) {
                setInProcess(false);
                if(result && result.apiResult){
                    displayData(result.apiResult)
                }
            },
        });
    };

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const updatedValue = event.target.value.trim();
        setValue(updatedValue);
    }

    const rowHeight = 48; // Height of each table row in pixels
    const maxTableHeight = 500; // Maximum height of the table in pixels
    const superSessiontableHeight = Math.min((supersessionData.length+1.2) * rowHeight, maxTableHeight);
    const serialLookTableHeight = Math.min((serialLookupData.length+1.2) * rowHeight, maxTableHeight);
    const modelLookupTableHeight = Math.min((modelLookupData.length+1.2) * rowHeight, maxTableHeight);
    const unitPartListTableHeight = Math.min((unitPartListData.length+1.2) * rowHeight, maxTableHeight);

    return (
        <StyledWrapper {...styles.formWrapper}>
            <form onSubmit={handleFormSubmit} autoComplete="off">
                <GridContainer {...styles.selectSourceSectionWrapper}>
                    <GridItem {...styles.selectSourceGridItem}>
                        <Select
                            {...styles.selectSourceDropdown}
                            label="Source"
                            sizeVariant="default"
                            value={source}
                            onChange={handleSelectedSource}
                            required
                            disabled={inProcess}
                        >
                            <option value="">{translate("Select Source")}</option>
                            <option value="serialLookup">{translate("Serial Number Lookup")}</option>
                            <option value="modelLookup">{translate("Model Number Lookup")}</option>
                            <option value="unitPartList">{translate("Component Number Lookup")}</option>
                            <option value="supersession">{translate("Item Details/Supersession Lookup")}</option>
                        </Select>
                    </GridItem>
                    <GridItem {...styles.numberLookUpGridItem}>
                        <TextField
                            {...styles.numberLookUpTextField}
                            label={translate("Search Number Lookup")}
                            name="searchNumber"
                            value={value}
                            onChange={handleChange}
                            placeholder={translate(placeholder)}
                            required
                            disabled={inProcess}
                        />
                    </GridItem>
                    <GridItem {...styles.searchGridItem}>
                        <Button
                            {...styles.searchButton}
                            type="submit"
                            disabled={inProcess}
                        >
                            {translate("Search")}
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>
            {
                (showResponse && source === "supersession" && supersessionData.length!==0) ?
                <SupersessionComponent responseData={supersessionData} tableHeight={superSessiontableHeight}/>
                :
                (showResponse && source === "serialLookup" && serialLookupData.length!==0) ?
                <SerialLookupComponent responseData={serialLookupData} tableHeight={serialLookTableHeight}/>
                :
                (showResponse && source === "modelLookup" && modelLookupData.length!==0) ?
                <ModelLookupComponent responseData={modelLookupData} tableHeight={modelLookupTableHeight}/>
                :
                (showResponse && source === "unitPartList" && unitPartListData.length!==0) &&
                <UnitPartListComponent responseData={unitPartListData} value={value} tableHeight={unitPartListTableHeight}/>
            }
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(SelectSourceForm),
    definition: {
        group: "Basic",
        displayName: "Select Source"
    },
};
export default widgetModule;